export default __webpack_public_path__ + "static/media/icon-pdf.53413e3e.svg";